import { forwardRef, memo } from 'react';
import map from 'lodash/map';
// Skillmore UI Components
import CardDeck from '@empathco/ui-components/src/elements/CardDeck';
// local imports
import { Skill } from '../models/skill';
import CheckedSkillCard from '../v3/CheckedSkillCard';

type CheckedSkillsGridProps = {
  readonly skills?: Skill[] | null;
  readonly onClick?: (id: number) => void;
  readonly checked?: boolean;
  readonly disabled?: boolean;
}

const CheckedSkillsGrid = forwardRef<HTMLDivElement, CheckedSkillsGridProps>(({
  skills,
  checked = false,
  onClick,
  disabled = false
}, ref) => (
  <CardDeck ref={ref}>
    {map(skills, (skill) => (
      <CheckedSkillCard
          key={skill.id}
          skill={skill}
          checked={checked}
          onChange={onClick}
          disabled={disabled}
      />
    ))}
  </CardDeck>
));

CheckedSkillsGrid.displayName = 'CheckedSkillsGrid';

export default memo(CheckedSkillsGrid);
